module.exports = __webpack_public_path__ + "../resources/images/illustration_folder-bec697d45da60bc52290d775eeccfaf2.svg";